<template>
  <UIDrawer
    :is-open
    :z-index
    :title="t('All clients')"
    direction="to-top"
    size="md"
    flat
    class="main-mobile-tree-drawer"
    @close="handleClose"
  >
    <ClientsTree />
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { useLocale } from '@/plugins/i18n'

import ClientsTree from './components/ClientsTree.vue'
import { UIDrawer } from '@ui/modals'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const { t } = useLocale('layouts.Main')

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.close()
}
</script>

<style>
.main-mobile-tree-drawer {
  .app-tree {
    @apply mb-safe-offset-4;
    @apply overflow-hidden;
  }

  .ui-tree__search,
  .ui-tree__container {
    @apply px-2;
  }

  .app-tree .ui-tree__item {
    @apply pr-2;
    @apply bg-body hover:bg-body-gray;
  }

  .app-tree__panel {
    @apply sticky bottom-0;
    @apply bg-body;
  }
}
</style>
